/**
 * Literales de UI de la vista Marketing (marketing.js + marketing-cupones.js).
 * Clave = texto español EXACTO tal como aparece en el código (estilo gettext).
 * Los globales (Guardar, Cancelar, Editar, Eliminar, Crear, Activo, Inactivo…)
 * viven en diccionario-comunes.js y NO se re-declaran acá.
 *
 * Terminología pt-BR canónica del proyecto: promoção, cupom, campanha, bônus,
 * indicação (referido), cashback, sorteio, aposta, modelo (plantilla).
 */

export const DICCIONARIO_MARKETING = {
    // ── Encabezados de tabla / data-labels ──────────────────────────────────
    Trigger: { pt: 'Gatilho', en: 'Trigger', ru: 'Триггер' },
    Recompensa: { pt: 'Recompensa', en: 'Reward', ru: 'Награда' },
    Usos: { pt: 'Usos', en: 'Uses', ru: 'Использования' },
    Promocion: { pt: 'Promoção', en: 'Promotion', ru: 'Акция' },
    Categoria: { pt: 'Categoria', en: 'Category', ru: 'Категория' },
    Autor: { pt: 'Autor', en: 'Author', ru: 'Автор' },
    'Promos recibidas': { pt: 'Promos recebidas', en: 'Promos received', ru: 'Полученные акции' },
    'Total recompensas': { pt: 'Total de recompensas', en: 'Total rewards', ru: 'Всего наград' },
    'Ultima promo': { pt: 'Última promo', en: 'Last promo', ru: 'Последняя акция' },
    'Fecha registro': { pt: 'Data de cadastro', en: 'Registration date', ru: 'Дата регистрации' },
    'Total apostado': { pt: 'Total apostado', en: 'Total wagered', ru: 'Всего поставлено' },
    Recibidas: { pt: 'Recebidas', en: 'Received', ru: 'Получено' },
    Ultima: { pt: 'Última', en: 'Last', ru: 'Последняя' },

    // ── Estados y botones ───────────────────────────────────────────────────
    Clonar: { pt: 'Clonar', en: 'Clone', ru: 'Клонировать' },
    Usar: { pt: 'Usar', en: 'Use', ru: 'Использовать' },
    'Marcar Influencer': { pt: 'Marcar Influencer', en: 'Mark as Influencer', ru: 'Отметить как инфлюенсера' },

    // ── Mensajes de carga / vacíos ──────────────────────────────────────────
    'Sin referidos': { pt: 'Sem indicações', en: 'No referrals', ru: 'Нет рефералов' },
    'El jugador apostó en varias monedas: no existe un total único': {
        pt: 'O jogador apostou em várias moedas: não existe um total único',
        en: 'The player bet in several currencies: there is no single total',
        ru: 'Игрок делал ставки в нескольких валютах: единой суммы не существует',
    },
    'Cliente no encontrado': { pt: 'Cliente não encontrado', en: 'Customer not found', ru: 'Клиент не найден' },
    'No hay promociones creadas. Usa el boton "Nueva Promocion" o activa una plantilla.': {
        pt: 'Não há promoções criadas. Use o botão "Nova Promoção" ou ative um modelo.',
        en: 'No promotions created. Use the "New Promotion" button or activate a template.',
        ru: 'Нет созданных акций. Нажмите кнопку «Новая акция» или активируйте шаблон.',
    },
    'No hay plantillas disponibles': {
        pt: 'Não há modelos disponíveis',
        en: 'No templates available',
        ru: 'Нет доступных шаблонов',
    },
    'No hay plantillas disponibles. Crea una primero.': {
        pt: 'Não há modelos disponíveis. Crie um primeiro.',
        en: 'No templates available. Create one first.',
        ru: 'Нет доступных шаблонов. Сначала создайте один.',
    },

    // ── Errores y toasts ────────────────────────────────────────────────────
    'Error al cargar promociones': {
        pt: 'Erro ao carregar promoções',
        en: 'Error loading promotions',
        ru: 'Ошибка загрузки акций',
    },
    'Error al cargar plantillas': {
        pt: 'Erro ao carregar modelos',
        en: 'Error loading templates',
        ru: 'Ошибка загрузки шаблонов',
    },
    'Error al buscar': { pt: 'Erro ao buscar', en: 'Search error', ru: 'Ошибка поиска' },
    'Error al cambiar estado': {
        pt: 'Erro ao alterar o status',
        en: 'Error changing status',
        ru: 'Ошибка изменения статуса',
    },
    'Error al eliminar promocion': {
        pt: 'Erro ao excluir a promoção',
        en: 'Error deleting promotion',
        ru: 'Ошибка удаления акции',
    },
    'Error al cargar la promocion': {
        pt: 'Erro ao carregar a promoção',
        en: 'Error loading the promotion',
        ru: 'Ошибка загрузки акции',
    },
    'Error al marcar como influencer': {
        pt: 'Erro ao marcar como influencer',
        en: 'Error marking as influencer',
        ru: 'Ошибка отметки как инфлюенсера',
    },
    'Plantilla actualizada': { pt: 'Modelo atualizado', en: 'Template updated', ru: 'Шаблон обновлён' },
    'Plantilla creada': { pt: 'Modelo criado', en: 'Template created', ru: 'Шаблон создан' },
    'Promocion actualizada': { pt: 'Promoção atualizada', en: 'Promotion updated', ru: 'Акция обновлена' },
    'Promocion creada': { pt: 'Promoção criada', en: 'Promotion created', ru: 'Акция создана' },
    Plantilla: { pt: 'Modelo', en: 'Template', ru: 'Шаблон' },
    eliminada: { pt: 'excluído', en: 'deleted', ru: 'удалена' },
    '¿Eliminar plantilla': { pt: 'Excluir o modelo', en: 'Delete template', ru: 'Удалить шаблон' },
    'Eliminar la promocion': { pt: 'Excluir a promoção', en: 'Delete the promotion', ru: 'Удалить акцию' },
    'Marcar este cliente como influencer?': {
        pt: 'Marcar este cliente como influencer?',
        en: 'Mark this customer as an influencer?',
        ru: 'Отметить этого клиента как инфлюенсера?',
    },

    // ── Títulos y botones del modal de promoción ────────────────────────────
    'Nueva Promocion (Scoped)': {
        pt: 'Nova Promoção (com escopo)',
        en: 'New Promotion (Scoped)',
        ru: 'Новая акция (с областью)',
    },
    'Editar Promocion': { pt: 'Editar Promoção', en: 'Edit Promotion', ru: 'Редактировать акцию' },
    'Nueva Plantilla': { pt: 'Novo Modelo', en: 'New Template', ru: 'Новый шаблон' },
    'Editar Plantilla': { pt: 'Editar Modelo', en: 'Edit Template', ru: 'Редактировать шаблон' },
    'Crear Plantilla': { pt: 'Criar Modelo', en: 'Create Template', ru: 'Создать шаблон' },
    'Guardar Plantilla': { pt: 'Salvar Modelo', en: 'Save Template', ru: 'Сохранить шаблон' },
    'Elegir Plantilla': { pt: 'Escolher Modelo', en: 'Choose Template', ru: 'Выбрать шаблон' },
    'Activar Plantilla:': { pt: 'Ativar Modelo:', en: 'Activate Template:', ru: 'Активировать шаблон:' },
    'Nueva Plantilla (desde:': { pt: 'Novo Modelo (a partir de:', en: 'New Template (from:', ru: 'Новый шаблон (из:' },
    copia: { pt: 'cópia', en: 'copy', ru: 'копия' },

    // ── Formulario y builder ────────────────────────────────────────────────
    'Nombre es obligatorio': { pt: 'Nome é obrigatório', en: 'Name is required', ru: 'Имя обязательно' },
    'Selecciona cuando se activa la promocion': {
        pt: 'Selecione quando a promoção é ativada',
        en: 'Select when the promotion is activated',
        ru: 'Выберите, когда активируется акция',
    },
    'Selecciona un tipo de recompensa': {
        pt: 'Selecione um tipo de recompensa',
        en: 'Select a reward type',
        ru: 'Выберите тип награды',
    },
    Valor: { pt: 'Valor', en: 'Value', ru: 'Значение' },
    '≤ Monto evento': { pt: '≤ Valor do evento', en: '≤ Event amount', ru: '≤ Сумма события' },
    '+ Agregar nivel': { pt: '+ Adicionar nível', en: '+ Add level', ru: '+ Добавить уровень' },
    Maximo: { pt: 'Máximo', en: 'Maximum', ru: 'Максимум' },
    niveles: { pt: 'níveis', en: 'levels', ru: 'уровни' },
    'Perdida hasta': { pt: 'Perda até', en: 'Loss up to', ru: 'Проигрыш до' },
    'Vacio = sin techo': { pt: 'Vazio = sem teto', en: 'Empty = no cap', ru: 'Пусто = без лимита' },
    'ID (ej: bronce)': { pt: 'ID (ex: bronze)', en: 'ID (e.g.: bronze)', ru: 'ID (напр.: бронза)' },
    'Meta:': { pt: 'Meta:', en: 'Goal:', ru: 'Цель:' },
    'Recompensa:': { pt: 'Recompensa:', en: 'Reward:', ru: 'Награда:' },
    '(sin acceso)': { pt: '(sem acesso)', en: '(no access)', ru: '(нет доступа)' },
    'Codigo:': { pt: 'Código:', en: 'Code:', ru: 'Код:' },

    // ── Placeholders del buscador ───────────────────────────────────────────
    'Buscar por telefono, nombre o promocion...': {
        pt: 'Buscar por telefone, nome ou promoção...',
        en: 'Search by phone, name or promotion...',
        ru: 'Поиск по телефону, имени или акции...',
    },
    'Buscar por nombre o codigo...': {
        pt: 'Buscar por nome ou código...',
        en: 'Search by name or code...',
        ru: 'Поиск по имени или коду...',
    },
    'Buscar por nombre, codigo o categoria...': {
        pt: 'Buscar por nome, código ou categoria...',
        en: 'Search by name, code or category...',
        ru: 'Поиск по имени, коду или категории...',
    },
    'Buscar por telefono o nombre...': {
        pt: 'Buscar por telefone ou nome...',
        en: 'Search by phone or name...',
        ru: 'Поиск по телефону или имени...',
    },
    'Buscar por telefono...': { pt: 'Buscar por telefone...', en: 'Search by phone...', ru: 'Поиск по телефону...' },

    // ── Resumen de recompensas ──────────────────────────────────────────────
    'Solo hitos': { pt: 'Apenas marcos', en: 'Milestones only', ru: 'Только вехи' },
    max: { pt: 'máx', en: 'max', ru: 'макс' },
    'Cashback por niveles': { pt: 'Cashback por níveis', en: 'Cashback by levels', ru: 'Кэшбэк по уровням' },
    Cashback: { pt: 'Cashback', en: 'Cashback', ru: 'Кэшбэк' },
    'Apuesta gratis': { pt: 'Aposta grátis', en: 'Free bet', ru: 'Бесплатная ставка' },
    Filon: { pt: 'Filão', en: 'Goldmine', ru: 'Золотая жила' },
    Notificacion: { pt: 'Notificação', en: 'Notification', ru: 'Уведомление' },
    Multinivel: { pt: 'Multinível', en: 'Multi-level', ru: 'Многоуровневый' },
    Equipo: { pt: 'Equipe', en: 'Team', ru: 'Команда' },

    // ── Cupones ─────────────────────────────────────────────────────────────
    'Campañas de Cupones': { pt: 'Campanhas de Cupons', en: 'Coupon Campaigns', ru: 'Купонные кампании' },
    Código: { pt: 'Código', en: 'Code', ru: 'Код' },
    'Emitidos / Total': { pt: 'Emitidos / Total', en: 'Issued / Total', ru: 'Выпущено / Всего' },
    Canjeados: { pt: 'Resgatados', en: 'Redeemed', ru: 'Погашено' },
    'Nueva campaña': { pt: 'Nova campanha', en: 'New campaign', ru: 'Новая кампания' },
    'No hay campañas de cupones. Crea una con el botón "Nueva campaña" para empezar a emitir.': {
        pt: 'Não há campanhas de cupons. Crie uma com o botão "Nova campanha" para começar a emitir.',
        en: 'No coupon campaigns. Create one with the "New campaign" button to start issuing.',
        ru: 'Нет купонных кампаний. Создайте одну с помощью кнопки «Новая кампания», чтобы начать выпуск.',
    },
    'Nueva campaña de cupones': {
        pt: 'Nova campanha de cupons',
        en: 'New coupon campaign',
        ru: 'Новая купонная кампания',
    },
    Campaña: { pt: 'Campanha', en: 'Campaign', ru: 'Кампания' },
    desactivada: { pt: 'desativada', en: 'deactivated', ru: 'деактивирована' },
    'Lluvia TV': { pt: 'Chuva TV', en: 'TV Rain', ru: 'ТВ-дождь' },

    // ── Tab Análisis: KPIs agnósticos de promociones ─────────────────────────
    Análisis: { pt: 'Análise', en: 'Analytics', ru: 'Аналитика' },
    Tipo: { pt: 'Tipo', en: 'Type', ru: 'Тип' },
    'Aplica a': { pt: 'Aplica a', en: 'Applies to', ru: 'Применяется к' },
    'Tipo de promoción': { pt: 'Tipo de promoção', en: 'Promotion type', ru: 'Тип акции' },
    'Evento que dispara el bono': {
        pt: 'Evento que dispara o bônus',
        en: 'Event that triggers the bonus',
        ru: 'Событие, запускающее бонус',
    },
    // Óptimos de industria (texto chico bajo cada KPI).
    'ideal ≥15%': { pt: 'ideal ≥15%', en: 'ideal ≥15%', ru: 'идеал ≥15%' },
    'sano ≤30%': { pt: 'saudável ≤30%', en: 'healthy ≤30%', ru: 'норма ≤30%' },
    'ideal ≥5x': { pt: 'ideal ≥5x', en: 'ideal ≥5x', ru: 'идеал ≥5x' },
    'ideal ≥3x': { pt: 'ideal ≥3x', en: 'ideal ≥3x', ru: 'идеал ≥3x' },
    'sano ≥90%': { pt: 'saudável ≥90%', en: 'healthy ≥90%', ru: 'норма ≥90%' },
    'ideal ≥80%': { pt: 'ideal ≥80%', en: 'ideal ≥80%', ru: 'идеал ≥80%' },
    // Dimensiones de negocio del veredicto (industria: revenue/retención/operativa).
    Ingresos: { pt: 'Receita', en: 'Revenue', ru: 'Доход' },
    Retención: { pt: 'Retenção', en: 'Retention', ru: 'Удержание' },
    Operativa: { pt: 'Operacional', en: 'Operational', ru: 'Операционная' },
    // Veredictos finales de la promo.
    'Excelente — supera los parámetros de industria': {
        pt: 'Excelente — supera os parâmetros do setor',
        en: 'Excellent — exceeds industry benchmarks',
        ru: 'Отлично — превышает отраслевые показатели',
    },
    'Saludable — dentro de los parámetros': {
        pt: 'Saudável — dentro dos parâmetros',
        en: 'Healthy — within benchmarks',
        ru: 'Норма — в пределах показателей',
    },
    'Necesita mejora — por debajo de lo esperable': {
        pt: 'Precisa melhorar — abaixo do esperado',
        en: 'Needs improvement — below expected',
        ru: 'Требует улучшения — ниже ожидаемого',
    },
    'Revisar — muy por debajo de los parámetros': {
        pt: 'Revisar — muito abaixo dos parâmetros',
        en: 'Review — well below benchmarks',
        ru: 'Проверить — значительно ниже показателей',
    },
    'Salud por dimensión': { pt: 'Saúde por dimensão', en: 'Health by dimension', ru: 'Здоровье по измерениям' },
    Activación: { pt: 'Ativação', en: 'Activation', ru: 'Активация' },
    Leverage: { pt: 'Alavancagem', en: 'Leverage', ru: 'Леверидж' },
    Wagering: { pt: 'Rollover', en: 'Wagering', ru: 'Отыгрыш' },
    'De cada 100 que reciben el bono': {
        pt: 'A cada 100 que recebem o bônus',
        en: 'Of every 100 who receive the bonus',
        ru: 'Из каждых 100, получивших бонус',
    },
    'lo usan': { pt: 'usam', en: 'use it', ru: 'используют' },
    'recargan su plata': {
        pt: 'recarregam o próprio dinheiro',
        en: 'top up their own money',
        ru: 'пополняют своими деньгами',
    },
    'se van con el bono': { pt: 'saem com o bônus', en: 'leave with the bonus', ru: 'уходят с бонусом' },
    'Costo por conversión': { pt: 'Custo por conversão', en: 'Cost per conversion', ru: 'Стоимость конверсии' },
    Conversión: { pt: 'Conversão', en: 'Conversion', ru: 'Конверсия' },
    'Costo en caja': { pt: 'Custo em caixa', en: 'Cash cost', ru: 'Затраты из кассы' },
    'Costo s/ recargado': { pt: 'Custo s/ recarregado', en: 'Cost vs topped up', ru: 'Затраты к пополнению' },
    'Fuga en caja': { pt: 'Vazamento em caixa', en: 'Cash leakage', ru: 'Утечка из кассы' },
    Indicadores: { pt: 'Indicadores', en: 'Indicators', ru: 'Показатели' },
    Cohorte: { pt: 'Coorte', en: 'Cohort', ru: 'Когорта' },
    Otorgado: { pt: 'Concedido', en: 'Granted', ru: 'Выдано' },
    Recurrencia: { pt: 'Recorrência', en: 'Recurrence', ru: 'Повторяемость' },
    inactiva: { pt: 'inativa', en: 'inactive', ru: 'неактивна' },
    'Ver análisis completo': { pt: 'Ver análise completa', en: 'View full analytics', ru: 'Полная аналитика' },
    'No hay promociones con actividad para analizar': {
        pt: 'Não há promoções com atividade para analisar',
        en: 'No promotions with activity to analyze',
        ru: 'Нет акций с активностью для анализа',
    },
    'No hay promociones con actividad': {
        pt: 'Não há promoções com atividade',
        en: 'No promotions with activity',
        ru: 'Нет акций с активностью',
    },
    'No se pudieron cargar los KPIs de promociones': {
        pt: 'Não foi possível carregar os KPIs das promoções',
        en: 'Could not load promotion KPIs',
        ru: 'Не удалось загрузить KPI акций',
    },
    // Categorías/tipos de promo (vienen de DB; se muestran crudos → traducir).
    Retencion: { pt: 'Retenção', en: 'Retention', ru: 'Удержание' },
    Adquisicion: { pt: 'Aquisição', en: 'Acquisition', ru: 'Привлечение' },
    Apuesta: { pt: 'Aposta', en: 'Bet', ru: 'Ставка' },
    Registro: { pt: 'Cadastro', en: 'Registration', ru: 'Регистрация' },

    // ── Dashboard: comparativa por sorteo (jugadas/premios/RTP) ──────────────
    'Jugadas vs Premios por sorteo': {
        pt: 'Apostas vs Prêmios por sorteio',
        en: 'Bets vs Prizes by draw',
        ru: 'Ставки и призы по тиражам',
    },
    'RTP por sorteo': { pt: 'RTP por sorteio', en: 'RTP by draw', ru: 'RTP по тиражам' },
    Jugadas: { pt: 'Apostas', en: 'Bets', ru: 'Ставки' },
    Premios: { pt: 'Prêmios', en: 'Prizes', ru: 'Призы' },
    '"Premios" es lo que ganó el jugador al momento del sorteo, aunque todavía no lo haya cobrado en caja. Puede no coincidir con el cierre del día.':
        {
            pt: '"Prêmios" é o que o jogador ganhou no momento do sorteio, mesmo que ainda não tenha sacado no caixa. Pode não bater com o fechamento do dia.',
            en: '"Prizes" is what the player won at the moment of the draw, even if not claimed at the register yet. May not match the day’s closing totals.',
            ru: '«Призы» — это то, что выиграл игрок в момент розыгрыша, даже если ещё не получил их в кассе. Может не совпадать с итогами закрытия дня.',
        },
    // ── "Minha rede" (dashboard operativo, fila Ganado vs Cobrado) ────────────
    'Cobrado en caja': { pt: 'Sacado no caixa', en: 'Claimed at register', ru: 'Получено в кассе' },
    'Ganado, pendiente de cobro': {
        pt: 'Ganho, pendente de saque',
        en: 'Won, pending claim',
        ru: 'Выиграно, ожидает получения',
    },
    Ganado: { pt: 'Ganho', en: 'Won', ru: 'Выиграно' },
    'Sin actividad por sorteo en el período': {
        pt: 'Sem atividade por sorteio no período',
        en: 'No activity by draw in the period',
        ru: 'Нет активности по тиражам за период',
    },
    'No se pudieron cargar los KPIs por sorteo': {
        pt: 'Não foi possível carregar os KPIs por sorteio',
        en: 'Could not load KPIs by draw',
        ru: 'Не удалось загрузить KPI по тиражам',
    },
    'Sin datos': { pt: 'Sem dados', en: 'No data', ru: 'Нет данных' },

    // ── Tab Tickets: promociones de tickets al portador ─────────────────────
    'Promociones de Tickets': {
        pt: 'Promoções de Tickets',
        en: 'Ticket Promotions',
        ru: 'Акции по билетам',
    },
    'Nueva promoción de ticket': {
        pt: 'Nova promoção de ticket',
        en: 'New ticket promotion',
        ru: 'Новая акция по билету',
    },
    'Editar promoción de ticket': {
        pt: 'Editar promoção de ticket',
        en: 'Edit ticket promotion',
        ru: 'Изменить акцию по билету',
    },
    'Ver plantillas': { pt: 'Ver modelos', en: 'View templates', ru: 'Показать шаблоны' },
    'Plantillas de tickets': { pt: 'Modelos de tickets', en: 'Ticket templates', ru: 'Шаблоны билетов' },
    'Activar plantilla': { pt: 'Ativar modelo', en: 'Activate template', ru: 'Активировать шаблон' },
    'Plantilla activada': { pt: 'Modelo ativado', en: 'Template activated', ru: 'Шаблон активирован' },
    'No hay promociones de tickets. Crea una con "Nueva promoción de ticket" o activa una plantilla.': {
        pt: 'Não há promoções de tickets. Crie uma com "Nova promoção de ticket" ou ative um modelo.',
        en: 'No ticket promotions. Create one with "New ticket promotion" or activate a template.',
        ru: 'Нет акций по билетам. Создайте через «Новая акция по билету» или активируйте шаблон.',
    },
    Efecto: { pt: 'Efeito', en: 'Effect', ru: 'Эффект' },
    Descuento: { pt: 'Desconto', en: 'Discount', ru: 'Скидка' },
    Mínimo: { pt: 'Mínimo', en: 'Minimum', ru: 'Минимум' },
    'Sorteo extra': { pt: 'Sorteio extra', en: 'Extra draw', ru: 'Дополнительный тираж' },
    'Apuestas gratis': { pt: 'Apostas grátis', en: 'Free bets', ru: 'Бесплатные ставки' },
    'Seguro contra cero': { pt: 'Seguro contra zero', en: 'Zero insurance', ru: 'Страховка от нуля' },
    'Multiplicador por tipo': {
        pt: 'Multiplicador por tipo',
        en: 'Multiplier by type',
        ru: 'Множитель по типу',
    },
    // Etiquetas de los tipos de efecto (select del modal)
    'Multiplicador de premio': {
        pt: 'Multiplicador de prêmio',
        en: 'Prize multiplier',
        ru: 'Множитель приза',
    },
    'Multiplicador por tipo de apuesta': {
        pt: 'Multiplicador por tipo de aposta',
        en: 'Multiplier by bet type',
        ru: 'Множитель по типу ставки',
    },
    'Bonus fijo al premio': { pt: 'Bônus fixo ao prêmio', en: 'Fixed prize bonus', ru: 'Фиксированный бонус к призу' },
    'Premio mínimo garantizado': {
        pt: 'Prêmio mínimo garantido',
        en: 'Guaranteed minimum prize',
        ru: 'Гарантированный минимальный приз',
    },
    // Etiquetas de campos del efecto
    'Multiplicador (ej. 1.5)': {
        pt: 'Multiplicador (ex. 1.5)',
        en: 'Multiplier (e.g. 1.5)',
        ru: 'Множитель (напр. 1.5)',
    },
    'Multiplicadores por tipo': {
        pt: 'Multiplicadores por tipo',
        en: 'Multipliers by type',
        ru: 'Множители по типу',
    },
    'Monto del bonus': { pt: 'Valor do bônus', en: 'Bonus amount', ru: 'Сумма бонуса' },
    'Monto mínimo': { pt: 'Valor mínimo', en: 'Minimum amount', ru: 'Минимальная сумма' },
    'Cantidad de sorteos extra': {
        pt: 'Quantidade de sorteios extra',
        en: 'Number of extra draws',
        ru: 'Количество доп. тиражей',
    },
    'Monto de descuento': { pt: 'Valor do desconto', en: 'Discount amount', ru: 'Сумма скидки' },
    'Porcentaje de descuento': { pt: 'Percentual de desconto', en: 'Discount percentage', ru: 'Процент скидки' },
    'Cantidad de apuestas gratis': {
        pt: 'Quantidade de apostas grátis',
        en: 'Number of free bets',
        ru: 'Количество бесплатных ставок',
    },
    'Este efecto no necesita parámetros.': {
        pt: 'Este efeito não precisa de parâmetros.',
        en: 'This effect needs no parameters.',
        ru: 'Этому эффекту не нужны параметры.',
    },
    'JSON: tipo de apuesta → multiplicador.': {
        pt: 'JSON: tipo de aposta → multiplicador.',
        en: 'JSON: bet type → multiplier.',
        ru: 'JSON: тип ставки → множитель.',
    },
    // Formulario
    'Texto impreso en el tiquete': {
        pt: 'Texto impresso no tíquete',
        en: 'Text printed on the ticket',
        ru: 'Текст на билете',
    },
    'Texto que se imprime en el tiquete físico (58mm)': {
        pt: 'Texto impresso no tíquete físico (58mm)',
        en: 'Text printed on the physical ticket (58mm)',
        ru: 'Текст, печатаемый на физическом билете (58мм)',
    },
    'Nombre visible de la promoción': {
        pt: 'Nome visível da promoção',
        en: 'Visible promotion name',
        ru: 'Отображаемое имя акции',
    },
    'Descripción interna (opcional)': {
        pt: 'Descrição interna (opcional)',
        en: 'Internal description (optional)',
        ru: 'Внутреннее описание (необязательно)',
    },
    'Solo letras, números, guion y guion bajo.': {
        pt: 'Apenas letras, números, hífen e sublinhado.',
        en: 'Only letters, numbers, hyphen and underscore.',
        ru: 'Только буквы, цифры, дефис и подчёркивание.',
    },
    'Heredable a nodos descendientes': {
        pt: 'Herdável para nós descendentes',
        en: 'Inheritable to descendant nodes',
        ru: 'Наследуется дочерними узлами',
    },
    // Validaciones y mensajes
    'El código es obligatorio': { pt: 'O código é obrigatório', en: 'Code is required', ru: 'Код обязателен' },
    'El nombre es obligatorio': { pt: 'O nome é obrigatório', en: 'Name is required', ru: 'Имя обязательно' },
    'El texto impreso en el tiquete es obligatorio': {
        pt: 'O texto impresso no tíquete é obrigatório',
        en: 'The text printed on the ticket is required',
        ru: 'Текст на билете обязателен',
    },
    'Tipo de efecto inválido': { pt: 'Tipo de efeito inválido', en: 'Invalid effect type', ru: 'Неверный тип эффекта' },
    'Completa al menos un campo del efecto': {
        pt: 'Preencha ao menos um campo do efeito',
        en: 'Fill at least one effect field',
        ru: 'Заполните хотя бы одно поле эффекта',
    },
    'Ingresa los multiplicadores por tipo (JSON)': {
        pt: 'Insira os multiplicadores por tipo (JSON)',
        en: 'Enter the multipliers by type (JSON)',
        ru: 'Введите множители по типу (JSON)',
    },
    'El JSON de multiplicadores por tipo no es válido': {
        pt: 'O JSON de multiplicadores por tipo não é válido',
        en: 'The multipliers-by-type JSON is not valid',
        ru: 'JSON множителей по типу недействителен',
    },
    'Falta el campo:': { pt: 'Falta o campo:', en: 'Missing field:', ru: 'Не заполнено поле:' },
    'Valor inválido en:': { pt: 'Valor inválido em:', en: 'Invalid value in:', ru: 'Неверное значение в:' },
    '¿Eliminar la promoción de ticket': {
        pt: 'Excluir a promoção de ticket',
        en: 'Delete the ticket promotion',
        ru: 'Удалить акцию по билету',
    },
    'Promoción creada': { pt: 'Promoção criada', en: 'Promotion created', ru: 'Акция создана' },
    'Promoción actualizada': { pt: 'Promoção atualizada', en: 'Promotion updated', ru: 'Акция обновлена' },
    Tickets: { pt: 'Tickets', en: 'Tickets', ru: 'Билеты' },
    'Ej.': { pt: 'Ex.', en: 'e.g.', ru: 'напр.' },
};
